import useProductsByCategoryId from './useProductsByCategoryId'

export default useProductsByCategoryId
